"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.buttonViews = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var mixins_1 = require("../../mixins");
var tokens_1 = require("../../tokens");
var utils_1 = require("../../utils");
/**
 * Размерные параметры шрифта
 */
var buttonTypography = {
    l: tokens_1.button1,
    m: tokens_1.button1,
    s: tokens_1.button2,
    xs: tokens_1.button2,
    xxs: tokens_1.caption,
    xxxs: tokens_1.caption,
};
/**
 * Размеры в пикселях по макету
 */
var sizes = {
    l: {
        height: '3.5rem',
        paddingY: '1rem',
        paddingX: '1.625rem',
        paddingXContent: '1.625rem',
        paddingXResizible: '1.25rem',
        squareRadius: '1rem',
        sOutlineRadius: '1.125rem',
        circleRadius: '1.75rem',
        cOutlineRadius: '1.875rem',
    },
    m: {
        height: '3rem',
        paddingY: '0.75rem',
        paddingX: '1.375rem',
        paddingXContent: '1.5rem',
        paddingXResizible: '1.25rem',
        squareRadius: '0.75rem',
        sOutlineRadius: '0.875rem',
        circleRadius: '1.5rem',
        cOutlineRadius: '1.625rem',
    },
    s: {
        height: '2.5rem',
        paddingY: '0.5rem',
        paddingX: '1.125rem',
        paddingXContent: '1.25rem',
        paddingXResizible: '1.25rem',
        squareRadius: '0.75rem',
        sOutlineRadius: '0.875rem',
        circleRadius: '1.25rem',
        cOutlineRadius: '1.375rem',
    },
    xs: {
        height: '2.25rem',
        paddingY: '0.5rem',
        paddingX: '0.625rem',
        paddingXContent: '0.625rem',
        paddingXResizible: '1.25',
        squareRadius: '0.625rem',
        sOutlineRadius: '0.75rem',
        circleRadius: '1.125rem',
        cOutlineRadius: '1.25rem',
    },
    xxs: {
        height: '2rem',
        paddingY: '0.4375rem',
        paddingX: '0.5rem',
        paddingXContent: '0.5rem',
        paddingXResizible: '0.875rem',
        squareRadius: '0.5625rem',
        sOutlineRadius: '0.6875rem',
        circleRadius: '1rem',
        cOutlineRadius: '1.125rem',
    },
    xxxs: {
        height: '1.75rem',
        paddingY: '0.3125rem',
        paddingX: '0.375rem',
        paddingXContent: '0.375rem',
        paddingXResizible: '0.875rem',
        squareRadius: '0.5rem',
        sOutlineRadius: '0.625rem',
        circleRadius: '0.875rem',
        cOutlineRadius: '1rem',
    },
};
/**
 * Цветовые стили
 */
exports.buttonViews = {
    primary: mixins_1.views.primary,
    secondary: mixins_1.views.secondary,
    warning: mixins_1.views.warning,
    critical: mixins_1.views.critical,
    checked: mixins_1.views.checked,
    overlay: mixins_1.views.overlay,
    clear: mixins_1.views.clear,
};
var StyledText = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n    ", "\n"], ["\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n    ", "\n"])), mixins_1.applyEllipsis, function (_a) {
    var isContentLeft = _a.isContentLeft;
    return isContentLeft && 'margin-left: 0.375rem;';
}, function (_a) {
    var isContentRight = _a.isContentRight;
    return isContentRight && 'margin-right: 0.375rem;';
});
/**
 * Миксин размеров кнопки по параметрам
 */
var applySizes = function (_a) {
    var size = _a.size, pin = _a.pin, outlined = _a.outlined, focused = _a.focused, isContentLeft = _a.isContentLeft, isContentRight = _a.isContentRight, shiftLeft = _a.shiftLeft, shiftRight = _a.shiftRight, square = _a.square, stretch = _a.stretch;
    var paddingX = sizes[size].paddingX;
    if (square) {
        paddingX = sizes[size].paddingY;
    }
    else if (stretch) {
        paddingX = sizes[size].paddingXResizible;
    }
    else if (isContentLeft || isContentRight) {
        paddingX = sizes[size].paddingXContent;
    }
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        height: ", ";\n        padding: ", " ", ";\n        border-radius: ", ";\n\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    "], ["\n        height: ", ";\n        padding: ", " ", ";\n        border-radius: ", ";\n\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ",
        "\n    "])), sizes[size].height, sizes[size].paddingY, paddingX, utils_1.convertRoundnessMatrix(pin, sizes[size].squareRadius, sizes[size].circleRadius), stretch && 'width: 100%;', square && " width: " + sizes[size].height + ";", shiftLeft && "margin-left: -" + paddingX + ";", shiftRight && "margin-right: -" + paddingX + ";", buttonTypography[size], mixins_1.addFocus({
        focused: focused,
        outlined: outlined,
        outlineRadius: utils_1.convertRoundnessMatrix(pin, sizes[size].sOutlineRadius, sizes[size].cOutlineRadius),
    }));
};
var StyledButton = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n\n    appearance: none;\n    border: none;\n    cursor: pointer;\n\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n    &:focus {\n        outline: none;\n    }\n\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    position: relative;\n\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n\n    appearance: none;\n    border: none;\n    cursor: pointer;\n\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n    &:focus {\n        outline: none;\n    }\n\n    ", "\n    ", "\n    ", "\n    ", "\n"])), mixins_1.applyView, applySizes, mixins_1.applyDisabled, mixins_1.applyBlur);
/**
 * Базовая кнопка.
 */
exports.Button = react_1.default.forwardRef(
// eslint-disable-next-line prefer-arrow-callback
function Button(_a, ref) {
    var square = _a.square, props = __rest(_a, ["square"]);
    var _b = props, text = _b.text, contentLeft = _b.contentLeft, contentRight = _b.contentRight, children = _b.children, rest = __rest(_b, ["text", "contentLeft", "contentRight", "children"]);
    var isContentLeft = Boolean(contentLeft);
    var isContentRight = Boolean(contentRight);
    return (react_1.default.createElement(StyledButton, __assign({ isContentLeft: isContentLeft, isContentRight: isContentRight, square: square !== undefined ? square : !text && !children, ref: ref }, rest),
        children,
        !children && contentLeft,
        !children && text && (react_1.default.createElement(StyledText, { isContentLeft: isContentLeft, isContentRight: isContentRight }, text)),
        !children && contentRight));
});
exports.Button.defaultProps = {
    pin: 'square-square',
    outlined: false,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Button.js.map